var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"story-footer"},[_c('a',{staticClass:"btn-read-full",attrs:{"href":_vm.storyUrl,"target":"_blank","rel":"noopener"}},[_vm._v("\n        Read full story\n        "),_c('ion-icon',{attrs:{"name":"ios-arrow-round-forward"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29155276","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story/StoryFooter.vue
// module id = null
// module chunks = 